<template>
  <div>
    <section class="content-header">
      <h1>
        Promociones
        <small>Control de promociones</small>
      </h1>
      <!--<ol class="breadcrumb">-->
        <!--<li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>-->
        <!--<li class="active">Dashboard</li>-->
      <!--</ol>-->
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="text-xs-center">
        <v-progress-circular
            :size="50"
            v-if="loading"
            color="primary"
            indeterminate
        ></v-progress-circular>
      </div>

      <v-alert
          :value="promotions.length === 0 && !loading"
          type="info"
          color="#1fabe2"
      >
        No tienes promociones activadas en este momento
      </v-alert>

      <div class="box" v-if="!loading && promotions.length > 0">
        <div class="box-body">
          <div class="nav-tabs-custom">
            <!-- Tabs within a box -->
            <ul class="nav nav-tabs pull-right">
              <li v-for="(promotionItem, key) in promotions" :key="`promotion_${key}`" :class="{active: (promotion === null && key === 0) || (promotion !== null && promotion.id === promotionItem.id)}"><a href="#" v-on:click.prevent="promotion = promotionItem">{{ promotionItem.name }}</a></li>
              <!--<li class="pull-left header"><i class="fa fa-inbox"></i> Sales</li>-->
            </ul>
            <div class="tab-content">

              <PromotionsSelectDealershipComponent v-if="promotion !== null" :promotion-id="promotion.id" v-on:dealershipChange="onDealershipChange" ref="dealershipsComponent"/>
              <PromotionSlotsTableComponent v-if="promotion !== null" :promotion="promotion" :dealership="dealership" v-on:refreshDealerships="refreshDealerships"/>
              <!--<div class="tab-pane active" style="position: relative; height: 300px;">{{ promotion }}</div>-->
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import WebService from '@/utils/webservice'
import PromotionsSelectDealershipComponent from '@/components/custom/promotions/PromotionsSelectDealershipComponent'
import PromotionSlotsTableComponent from '@/components/custom/promotions/PromotionSlotsTableComponent'
export default {
  name: 'PagePromotionsComponent',
  components: {PromotionSlotsTableComponent, PromotionsSelectDealershipComponent},
  data () {
    return {
      loading: true,
      dealership: null,
      promotion: null,
      promotions: []
    }
  },

  watch: {

    promotion (newPromotion, oldPromotion) {
      this.dealership = null
    }

  },

  methods: {
    onDealershipChange (dealership) {
      this.dealership = dealership
    },

    refreshDealerships () {
      this.$refs.dealershipsComponent.requestDealerships()
    }
  },

  mounted () {
    this.loading = true
    WebService.promotions.findPromotions().then(promotions => {
      this.promotions = promotions
      if (this.promotions.length > 0) {
        this.promotion = this.promotions[0]
      }
      this.loading = false
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/PagePromotionsComponent.vue